import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MessagesService {

    constructor(private http: HttpClient) { }

    getAllMessages() {
        let variable=JSON.parse(localStorage.getItem("currentUser"));
        let codinter= variable.codinter;
        return this.http.get(`${environment.baseUrl}/mensajeria/getAllMensajes.php?idepol=${codinter}`);
    }

}